import { Box, Stack, Typography } from "@mui/material"
import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext } from "react";

export function DashboardButton({...params}){

    const { mode } = useContext(ThemeContext);

    let dashboardButtonState = params.dashboardButtonState
    let setDashboardButtonState = params.setDashboardButtonState
    let handleClick = params.handleClick

    let lightPaths = ["/icons/icons-light/icon-dashboard-light-active.svg", "/icons/icons-light/icon-dashboard-light-default.svg", "/icons/icons-light/icon-dashboard-light-hover.svg"]
    let darkPaths = ["/icons/icons-dark/icon-dashboard-dark-active.svg", "/icons/icons-dark/icon-dashboard-dark-default.svg", "/icons/icons-dark/icon-dashboard-dark-hover.svg"]

    let lightColors = ["#02203B", "#06569D", "#138BF6"]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"]

    let onButtonPage = false
    let url = window.location.pathname
    if (url === '/') onButtonPage = true

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (onButtonPage) setDashboardButtonState('hover')
        else if (dashboardButtonState !== 'active') setDashboardButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setDashboardButtonState('default')
        if (onButtonPage) setDashboardButtonState('active')
        else if (dashboardButtonState !== 'active') setDashboardButtonState('default')
    }

    let imagePath = ''
    let labelColor = ''

    if (mode === 'light'){
        if (dashboardButtonState === 'active') {imagePath = lightPaths[0]; labelColor = lightColors[0]}
        else if (dashboardButtonState === 'default') {imagePath = lightPaths[1]; labelColor = lightColors[1]}
        else if (dashboardButtonState === 'hover') {imagePath = lightPaths[2]; labelColor = lightColors[2]}
    } 
    else if (mode === 'dark'){
        if (dashboardButtonState === 'active') {imagePath = darkPaths[0]; labelColor = darkColors[0]}
        else if (dashboardButtonState === 'default') {imagePath = darkPaths[1]; labelColor = darkColors[1]}
        else if (dashboardButtonState === 'hover') {imagePath = darkPaths[2]; labelColor = darkColors[2]}
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: labelColor, width: '71px', height: '10px'}

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>

            <Box component="img" src={imagePath} width={'33px'} height={'45px'} paddingBottom={'10px'}  id={"DashboardButton"}/>
            <Typography sx={[labelFormatting, labelStyling]}>Dashboard</Typography>
        </Stack>
    )
}
